module.exports = __webpack_public_path__ + "img/mealreminder-text-2-white.8aaf3d6f.png";